module.exports = __webpack_public_path__ + "images/dingtalk/init-stars-help-66790b4818651ac68b9e761ee6e015d1.png";